<template>
  <div class="layout">
    <header>
      <Header :LogoUrl="gsInfo.web_logo" @changeLang="changeLang"></Header>
      <NavMenu :navList="navList"></NavMenu>
    </header>
    <main>
      <router-view> </router-view>
      <!-- 引入回到顶部 -->
      <back-top></back-top>
    </main>
    <footer>
      <Footer :gsInfo="gsInfo" :footerNavList="footerNavList"></Footer>
    </footer>
  </div>
</template>

<script>
import Header from "./Header";
import Search from "@/components/Search";
import NavMenu from "./Navmenu.vue";
import Footer from "./Footer.vue";
import BackTop from "./BackTop";
export default {
  props: {},
  data() {
    return {
      isLogin: localStorage.getItem("isLogin") - 0 || 0,
      isVisible: false,
      navList: [],
      footerNavList: [],
      gsInfo: {},
      lang: "",
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.lang = this.$store.state.app.language;
    this.getNavMenu();
    this.getGsInfo();
    this.getFooterNav();
    // window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {},
  methods: {
    async getNavMenu() {
      let params = {
        posid: 1,
        lang: this.lang,
      };
      try {
        const res = await this.$http.fetchGet("/index/getnavs", params);
        if (res.code == 1) {
          localStorage.setItem("navList", JSON.stringify(res.data));
          this.$store.dispatch("setLanguage", this.lang);
          this.navList = res.data;
          if(this.lang !== "cn") {
            for(let i = 0; i < this.navList.length; i++) {
              if(this.navList[i].nav_id == 22) {
                this.navList.splice(i, 1);
              }
            }
          }
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    async getGsInfo() {
      try {
        const res = await this.$http.fetchPost("/index/getFooter");
        if (res.code == 1) {
          // this.companyInfo = res.data;
          if(this.lang == "en") {
            this.gsInfo = res.data.en;
          }else if(this.lang == "ru") {
            this.gsInfo = res.data.ru;
          }else {
            this.gsInfo = res.data.cn;
          }
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    async getFooterNav() {
      let params = {
        posid: 2,
        lang: this.lang,
      };
      try {
        const res = await this.$http.fetchPost("/index/getnavs", params);
        if (res.code == 1) {
          this.footerNavList = res.data;
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    changeLang(lang) {
      this.lang = lang;
      this.$i18n.locale = lang;
      this.getNavMenu();
      this.getGsInfo();
      this.getFooterNav();
      localStorage.setItem("lang", lang);
    },
    handleScroll() {
      const isShow = window.scrollY > 300; // 当滚动超过 300px 显示按钮
      this.$emit("update:isVisible", isShow);
    },
  },
  components: {
    Header,
    Search,
    NavMenu,
    Footer,
    BackTop,
    BackTop,
  },
};
</script>

<style scoped lang="scss">
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  main {
    flex: 1;
  }
}

// header,
// footer {
//   background-color: #f2f2f2;
//   // padding: 20px;
//   // text-align: center;
// }

// main {
//   flex: 1;
// }
</style>
